import { render, staticRenderFns } from "./AdminCoupons.vue?vue&type=template&id=5b42319b"
import script from "./AdminCoupons.vue?vue&type=script&lang=js"
export * from "./AdminCoupons.vue?vue&type=script&lang=js"
import style0 from "./AdminCoupons.vue?vue&type=style&index=0&id=5b42319b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports